import { FC } from 'react';
import useCustomKycRequests from './useCustomKycRequests';
import CustomRequestForm from '../CustomRequestForm';

type Props = {
  vehicleId: string;
};

const CustomKycRequests: FC<Props> = ({ vehicleId }) => {
  const {
    customKycRequests,
    handleCustomRequestsOrderChange,
    addCustomKycRequest,
    updateCustomKycRequest,
    deleteCustomKycRequest,
    isLoading: isLoadingCustomKycRequests,
  } = useCustomKycRequests(vehicleId);

  return (
    <CustomRequestForm
      customRequests={customKycRequests}
      handleCustomRequestsOrderChange={handleCustomRequestsOrderChange}
      addRequest={(values, onSuccess) => {
        addCustomKycRequest(
          {
            vehicleId,
            ...values,
          },
          { onSuccess },
        );
      }}
      updateRequest={(id, values, onSuccess) => {
        updateCustomKycRequest(
          {
            id,
            vehicleId,
            ...values,
          },
          { onSuccess },
        );
      }}
      deleteRequest={(id) => {
        deleteCustomKycRequest({
          id,
          vehicleId,
        });
      }}
      isLoading={isLoadingCustomKycRequests}
    />
  );
};

export default CustomKycRequests;
